"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../header"));

var _CsvImport = _interopRequireDefault(require("../../preact-components/file-import/CsvImport"));

var _axios = _interopRequireDefault(require("axios"));

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var _csrfToken = require("../../preact-components/utils/csrfToken");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _ContactInviteModal = _interopRequireDefault(require("./ContactInviteModal"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContactImport = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContactImport, _Component);

  var _super = _createSuper(ContactImport);

  function ContactImport(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContactImport);
    _this = _super.call(this, props);

    _this.setState({
      showImportSuccess: false,
      showImportError: false,
      showContactInviteModal: false,
      isLoading: false
    });

    _this.onImportContacts = _this.onImportContacts.bind((0, _assertThisInitialized2.default)(_this));
    _this.onContactsInvited = _this.onContactsInvited.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContactImport, [{
    key: "onImportContacts",
    value: function () {
      var _onImportContacts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(file) {
        var _this2 = this;

        var localDateTime, defaultUserTag, formData;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                localDateTime = String((0, _dateFormatting.default)(Date.now() / 1000).replace(',', ''));
                defaultUserTag = "CSV import - ".concat(localDateTime);
                formData = new window.FormData();
                formData.append('contacts', file);
                formData.append('userTags', JSON.stringify([defaultUserTag]));
                formData.append('yip_csrf_token', (0, _csrfToken.csrfToken)());
                _context.next = 9;
                return _axios.default.post('/contact/upload', formData).then(function (res) {
                  _this2.setState({
                    showImportSuccess: true,
                    isLoading: false,
                    uploadedCount: res.data.importedContacts,
                    errors: res.data.errors,
                    importId: res.data.importId
                  });
                }).catch(function (error) {
                  var response = error.response.data;

                  if ('error' in response) {
                    _this2.setState({
                      showImportError: true,
                      alertMessage: response.error,
                      alertMessageType: 'error',
                      isLoading: false
                    });
                  } else {
                    _this2.setState({
                      showImportError: true,
                      isLoading: false
                    });
                  }
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onImportContacts(_x) {
        return _onImportContacts.apply(this, arguments);
      }

      return onImportContacts;
    }()
  }, {
    key: "onContactsInvited",
    value: function onContactsInvited(success) {
      var isGroupInvite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.setState({
        alertMessageType: success ? 'success' : 'error',
        alertMessage: success ? 'Invitations have been sent successfully!' : 'Something went wrong, please try again.',
        showContactInviteModal: false
      });
      if (!success) return;

      _publish.default.trackEvent('userevent', {
        type: 'Contact Invited',

        /* eslint-disable no-restricted-syntax */
        total_contacts_invited: this.state.uploadedCount,
        invite_type: isGroupInvite ? 'join user group' : 'join community'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          showImportSuccess = _this$state.showImportSuccess,
          showImportError = _this$state.showImportError,
          showContactInviteModal = _this$state.showContactInviteModal,
          isLoading = _this$state.isLoading,
          uploadedCount = _this$state.uploadedCount,
          errors = _this$state.errors,
          alertMessage = _this$state.alertMessage,
          alertMessageType = _this$state.alertMessageType,
          importId = _this$state.importId;
      return (0, _preact.h)("div", {
        className: "contact-import"
      }, (0, _preact.h)(_header.default, {
        title: "Import Contact",
        disableSaveButton: true,
        disableCancelButton: true,
        hasBreadcrumb: true,
        breadcrumbText: "Contact Overview",
        breadcrumbLink: "/contact/overview"
      }), alertMessageType && (0, _preact.h)(_AlertComponent.default, {
        messageType: alertMessageType,
        message: alertMessage,
        sticky: true,
        isVisibleFor: 5000,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this3.setState({
            alertMessageType: undefined,
            alertMessage: ''
          });
        },
        onClose: function onClose() {
          return _this3.setState({
            alertMessageType: undefined,
            alertMessage: ''
          });
        }
      }), (0, _preact.h)(_CsvImport.default, {
        infoText: "Please upload a CSV file containing email address and name.",
        calloutText: "Importing contacts via csv allows you to add multiple contacts at once. If an email address in your CSV matches an existing email address of a user or contact, they will not be added.",
        uploadFile: this.onImportContacts,
        showImportSuccess: showImportSuccess,
        showImportError: showImportError,
        onTryAgain: function onTryAgain() {
          return _this3.setState({
            showImportError: false
          });
        },
        isLoading: isLoading,
        uploadedCount: uploadedCount,
        errors: errors,
        type: "contact",
        successAction: uploadedCount && (0, _preact.h)(_buttonControl.default, {
          title: "Send invite to all ".concat(uploadedCount, " imported contact").concat(uploadedCount > 1 ? 's' : ''),
          newStyle: true,
          onClick: function onClick() {
            return _this3.setState({
              showContactInviteModal: true
            });
          },
          size: "medium",
          variant: "brand"
        })
      }), importId && (0, _preact.h)(_ContactInviteModal.default, {
        importId: importId,
        isOpen: showContactInviteModal,
        contactCount: uploadedCount || 0,
        onClose: function onClose() {
          return _this3.setState({
            showContactInviteModal: false
          });
        },
        onContactsInvited: this.onContactsInvited
      }));
    }
  }]);
  return ContactImport;
}(_preact.Component);

var _default = ContactImport;
exports.default = _default;